import FilterLabel from './FilterLabel';
export default FilterLabel;



// WEBPACK FOOTER //
// ./src/components/Buildings/FilterLabel/index.js